import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const updateCustomizationData = async ({ data }: { data: Object }) => {

  const reqBody = {
    customization_data: data
  };

  return axiosPrivate.post(`/dashboard/api/v1/checkout-customization/create`, reqBody);
};